export default __webpack_public_path__ + "static/media/task-message-fill.b9c1cf0b.svg";